import type { CalendarResponse, ScheduledPost } from '@qlk/shared';

import { ONgay } from './LuoiTuan.js';
import { TEN_THU, khoaNgayVn } from './gioThiTruong.js';

export interface LuoiThangProps {
  lich: CalendarResponse;
  onMo?: (post: ScheduledPost) => void;
}

function thuIso(khoa: string): number {
  const thu = new Date(`${khoa}T00:00:00Z`).getUTCDay();
  return thu === 0 ? 7 : thu;
}

export function LuoiThang({ lich, onMo }: LuoiThangProps) {
  const homNay = khoaNgayVn(new Date());
  const dauThang = lich.days[0];
  const oTrong = dauThang ? thuIso(dauThang.date) - 1 : 0;

  return (
    <div className="overflow-x-auto pb-2">
      <div className="min-w-[1000px]">
        <div className="mb-2 grid grid-cols-7 gap-4">
          {TEN_THU.map((t) => (
            <p key={t} className="text-phu font-medium text-chu-mo">
              {t}
            </p>
          ))}
        </div>

        <div className="grid grid-cols-7 gap-4">
          {Array.from({ length: oTrong }, (_, i) => (
            <div key={`trong-${String(i)}`} aria-hidden="true" />
          ))}

          {lich.days.map((ngay) => (
            <ONgay
              gon
              key={ngay.date}
              date={ngay.date}
              nhan=""
              posts={ngay.posts}
              homNay={ngay.date === homNay}
              onMo={onMo}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
